export enum IndicatorMeta {
	indicatorOneTargetValue = 45,
	indicatorTwoTargetValue = 60,
	indicatorThreeTargetValue = 60,
	indicatorFourTargetValue = 40,
	indicatorFiveTargetValue = 95,
	indicatorSixTargetValue = 50,
	indicatorSevenTargetValue = 50,
}
